module.exports = __webpack_public_path__ + "ae4f2de6ca000de01011ae0eb8ece5c5.svg";